import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        accentLightBlue: '#2A429E',
        accentDarkBlue: '#374785',
        accentMediumBlue: '#24305E',
        warning: '#FFAA2C',
        error: '#F83E70',
        info: '#3CD1C2',
      }
    }
  }
});